import styled from "@emotion/styled"
import {
	breakpoint,
	colorContrastLower,
	gridGap,
	spacingStaticSm,
} from "@porsche-design-system/components-react/emotion"
import { shouldForwardProp } from "src/common/shouldForwardProp"
import { SkeletonHeading } from "./SkeletonHeading"
import { SkeletonText } from "./SkeletonText"

interface SkeletonListProps {
	entries?: number
	withHeader?: boolean
}

export const SkeletonList = ({ entries = 4, withHeader }: SkeletonListProps) => {
	const rows = (
		<ItemsWrapper $withHeader={withHeader}>
			{Array.from({ length: entries }, (_, i) => (
				<Item key={i}>
					<StyledSkeletonText />
					<StyledSkeletonText />
				</Item>
			))}
		</ItemsWrapper>
	)

	return withHeader ? (
		<Wrapper>
			<StyledSkeletonHeading size="sm" />
			{rows}
		</Wrapper>
	) : (
		rows
	)
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticSm};
`

const StyledSkeletonHeading = styled(SkeletonHeading)`
	width: 25%;
	
	@media (min-width: ${breakpoint.xs}px) {
		width: 40%;
	}
`

const StyledSkeletonText = styled(SkeletonText)`
	width: 50%;

	@media (min-width: ${breakpoint.xs}px) {
		width: 60%;
	}
`

const ItemsWrapper = styled("div", { shouldForwardProp })<{ $withHeader?: boolean }>`
	${({ $withHeader }) =>
		// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
		$withHeader ? `border-top: 1px solid ${colorContrastLower};` : `${Item}:first-of-type { padding-top: 0; }`}
`

const Item = styled.div`
	display: grid;
	border-bottom: 1px solid ${colorContrastLower};
	padding: calc(${spacingStaticSm} - 1px) 0;
	gap: 2px;

	@media (min-width: ${breakpoint.xs}px) {
		padding: ${spacingStaticSm} 0;
		gap: ${gridGap};
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	}
`
